<template>
  <v-content class="client organization page" v-if="organization">
    <Header :organization="organization" :edit="canEdit" />

    <v-container grid-list-md >
      <Publish :organization="organization" :edit="canEdit" />
      <Overview :organization="organization" :edit="canEdit" />
      <v-layout row wrap>
        <v-flex d-flex xs12 md6>
          <Summary :organization="organization" :edit="canEdit" />
        </v-flex>
        <v-flex d-flex xs12 md6 style="flex-flow:column">
          <Culture :organization="organization" :edit="canEdit" />
          <Blurb :organization="organization" :edit="canEdit" />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex d-flex xs12 md6>
          <Gallery :organization="organization" :edit="canEdit" />
        </v-flex>
        <v-flex d-flex xs12 md6>
          <Video :organization="organization" :edit="canEdit" />
        </v-flex>
      </v-layout>
      <Locations :organization="organization" :edit="canEdit" />
      <PressLinks :links="organization.pressLinks" v-if="organization.pressLinks" />
      <SocialMedia :organization="organization"  :edit="canEdit" />
    </v-container>

  </v-content>
</template>

<script>
// Mixins
import {managedDocumentAttributes} from '@/mixins/managedDocumentAttributes.js'
import Blurb from '@/components/client/organization/Blurb'
import Culture from '@/components/client/organization/Culture'
import Gallery from '@/components/client/organization/Gallery'
import Header from '@/components/client/organization/Header'
import Locations from '@/components/client/organization/Locations'
import Overview from '@/components/client/organization/Overview'
import PressLinks from '@/components/client/organization/PressLinks'
import Publish from '@/components/client/organization/Publish'
import SocialMedia from '@/components/client/organization/SocialMedia'
import Summary from '@/components/client/organization/Summary'
import Video from '@/components/client/organization/Video'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  mixins: [managedDocumentAttributes],

  components: {
    Blurb,
    Culture,
    Gallery,
    Locations,
    Header,
    Overview,
    PressLinks,
    Publish,
    SocialMedia,
    Summary,
    Video,
  },
  created() {
    this.$store.dispatch('client/organization/fetch').then(() => {
      this.documentAttributes.title = `${this.organization.name} – Leaply`
      this.documentAttributes.description = this.organization.blurb
    })
  },
  computed: {
    ...mapGetters({
      organization: 'client/organization/model',
      user: 'auth/user',
    }),
    canEdit() {
      return false
    },
  },
}
</script>
